import { ensureGsap, prefersReducedMotion } from "@/shared/lib/gsap";
import { useEffect, useRef } from "react";

interface CountUpOptions {
  target: number;
  duration?: number;
  suffix?: string;
}

/** Number counter triggered when element enters viewport. */
export function useCountUp(options: CountUpOptions) {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const gsap = ensureGsap();
    const el = ref.current;
    if (!gsap || !el) return;

    const suffix = options.suffix ?? "";
    const finalText = `${options.target}${suffix}`;

    if (prefersReducedMotion()) {
      el.textContent = finalText;
      return;
    }

    const obj = { value: 0 };
    el.textContent = `0${suffix}`;

    const tween = gsap.to(obj, {
      value: options.target,
      duration: options.duration ?? 1.4,
      ease: "power2.out",
      onUpdate: () => {
        el.textContent = `${Math.round(obj.value)}${suffix}`;
      },
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true,
      },
    });

    return () => {
      tween.scrollTrigger?.kill();
      tween.kill();
    };
  }, [options.target, options.duration, options.suffix]);

  return ref;
}
